import {
  SAVE_PROMOTION_INFORMATION,
  SAVE_SELECTED_RECEPIENDS,
  SAVE_COMMON_POINTS_FOR_ALL_RECEPIENTS,
  SET_CHECKBOX_FOR_EACH_RECEPIENTS,
  SAVE_POINTS_FOR_SINGLE_MULTI_USER,
  SAVE_BEHAVIOUR_DETAILS,
  ADD_POINTS_FOR_CUSTOM_USER,
  SET_CHECKBOX_FOR_RECOGNITION_PRIVATE,
  SAVE_UPLOADED_IMAGE_INFO,
  GET_ALL_SELECTED_PROMOTION,
  ALL_PROMOTION,
  SENT_RECOGNITION_INFORMATION,
  SAVE_LOGIN_RESPONSE,
  SAVE_TEAM_MEMBER_LIST,
  SAVE_RECOGNIZE_LIST,
  USER_DETAILS,
  FILTERS,
  SAVE_COPYOTHERS_RECEPIENDS,
  REMOVE_COPYOTHERS_RECEPIENDS,
  SET_COPY_MANAGER,
  SET_COPY_ME,
  COPY_OTHERS_EMAIL,
  SELECTED_PARTICIPANT_ID,
  RESTORE_RECEPIENDS,
  CLEAR_COPY_OTHERS_EMAIL
} from "../action/actionTypes";

const initialState = {
  recepients: [],
  copyOthersRecepients: [],
  promotion: {},
  numberObj: {},
  checked: false,
  singleMultiUserPoints: [],
  sum: 0,
  behaviour: {},
  customPoints: [],
  private: false,
  copymanager: false,
  copyme : false,
  manualImageInfo: {},
  selectedAllPromotions: [],
  PromotionList: [],
  recongnitionInfo: [],
  loginInfo: [],
  teamMemberList: [],
  submittedRecognizeList: [],
  userDetails: [],
  participantId : [],
  copyothersemail: "",
  filters: {
    jobTitle: "",
    department: "",
    location: "",
    country: "",
    group: "",
  },
};

const commonReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_PROMOTION_INFORMATION:
      return {
        ...state,
        promotion: action.promotion,
      };
    case SAVE_SELECTED_RECEPIENDS:
      return {
        ...state,
        recepients: action.item,
      };
      case SELECTED_PARTICIPANT_ID:
      return {
        ...state,
        participantIds: action.data,
      };
    case SAVE_COPYOTHERS_RECEPIENDS:
        return {
          ...state,
          copyOthersRecepients: action.item,
    };
    case RESTORE_RECEPIENDS:
        return {
          copyOthersRecepients: action.item,
    };
    case REMOVE_COPYOTHERS_RECEPIENDS:
        return {
          ...state,
          copyOthersRecepients: state.copyOthersRecepients.filter((item: any) => item.key !== action.item.key)
    };
    case SAVE_COMMON_POINTS_FOR_ALL_RECEPIENTS:
      return {
        ...state,
        numberObj: action.numberObj,
      };
    case SET_CHECKBOX_FOR_EACH_RECEPIENTS:
      return {
        ...state,
        checked: action.checked,
      };
    case SAVE_POINTS_FOR_SINGLE_MULTI_USER:
      return {
        ...state,
        singleMultiUserPoints: action.data,
        sum: action.sum,
      };
    case SAVE_BEHAVIOUR_DETAILS:
      return {
        ...state,
        behaviour: action.data,
      };
    case ADD_POINTS_FOR_CUSTOM_USER:
      return {
        ...state,
        customPoints: action.points,
      };
    case SET_CHECKBOX_FOR_RECOGNITION_PRIVATE:
      return {
        ...state,
        private: action.checked,
      };
      case COPY_OTHERS_EMAIL:
      return {
        ...state,
        copyothersemail: action.data,
      };
      case CLEAR_COPY_OTHERS_EMAIL:
        return {
          ...state,
          copyothersemail: '',
        };
      case SET_COPY_MANAGER:
      return {
        ...state,
        copymanager: action.checked,
      };
      case SET_COPY_ME:
      return {
        ...state,
        copyme: action.checked,
      };
    case SAVE_UPLOADED_IMAGE_INFO:
      return {
        ...state,
        manualImageInfo: action.data,
      };
    case GET_ALL_SELECTED_PROMOTION:
      return {
        ...state,
        selectedAllPromotions: [...state.selectedAllPromotions, action.data],
      };
    case ALL_PROMOTION:
      return {
        ...state,
        PromotionList: action.data,
      };
    case SENT_RECOGNITION_INFORMATION:
      return {
        ...state,
        recongnitionInfo: action.data,
      };
    case SAVE_LOGIN_RESPONSE:
      return {
        ...state,
        loginInfo: action.data,
      };
    case SAVE_TEAM_MEMBER_LIST:
      return {
        ...state,
        teamMemberList: action.data,
      };
    case SAVE_RECOGNIZE_LIST:
      return {
        ...state,
        submittedRecognizeList: [...state.submittedRecognizeList, action.data],
      };
    case USER_DETAILS:
      return {
        ...state,
        userDetails: action.data,
      };
    case FILTERS:
      return {
        ...state,
        filters: action.data,
      };
    default:
      return state;
  }
};

export default commonReducer;
